import { OrganizationKeyName } from "../../../model/Organization";

export const GET_NEWS_FAIL = "SHOP:GET_NEWS_FAIL";

export const getNewsFailAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_NEWS_FAIL as typeof GET_NEWS_FAIL,
  organization,
  id,
});

export type GetNewsFailAction = ReturnType<typeof getNewsFailAction>;
